export interface Tab {
    slug: string;
    title: string;
    template: string;
    kpi: string[];
    col1: string[];
    col2: string[];
    col3: string[];
}

export const tabs: Tab[] = [
    {
        slug: 'annonce',
        title: 'Annonce',
        template: '1/1-1',
        kpi: [
            'price',
            'square',
            'square-price',
            'square-price-diff',
            'first-date',
        ],
        col1: [
            'photo',
            'descriptif',
            'contact',
        ],
        col2: [
            'notes',
            'information-general',
            'verif-data',
            'localisation',
            'price-evol',
        ],
        col3: [],
    },
    {
        slug: 'ville',
        title: 'Ville ',
        template: '1/1-1',
        kpi: [
            'habitant',
            'city-square-price',
            'price-city-evol',
            'city-efficiency',
            'tension-locative',
        ],
        col1: [
            'population',
            'prix-moyen',
            'population-activity',
            'commodite-ville',
            'pyramide-ages',
            'etudiant',
            'menages',
            'entreprises',
            'services-ville',
            'tourisme',
        ],
        col2: [
            'evol-prix-immo',
            'city-map',
            'repartition',
            'loyer-moyen',
            'tensiometre',
            'ville-lien',
            'commerces',
            'logements',
        ],
        col3: [],
    },
    // {
    //     slug: 'travaux',
    //     title: 'Travaux',
    //     template: '1/1',
    //     kpi: [
    //         'total-travaux',
    //         'part-travaux',
    //         'square-work',
    //     ],
    //     col1: [
    //         ,
    //     ],
    //     col2: [],
    //     col3: [],
    // },
    {
        slug: 'inout',
        title: 'Rendement',
        template: '1/1-1',
        kpi: [
            'total-loyer',
            'total-sortie',
            'cash-flow',
            'rendement-brut',
            'rendement-net',
            'fisca-mobile',
        ],
        col1: [
            'achat',
            'revenus',
            'simulateur-travaux',
        ],
        col2: [
            'charges',
            'financement',
            'simulator',
        ],
        col3: [],
    },
    {
        slug: 'impot',
        title: 'Imposition',
        template: '1/1',
        kpi: [],
        col1: [
            'config-impots'
        ],
        col2: [],
        col3: [],
    },
    {
        slug: 'recap',
        title: 'Récapitulatif',
        template: '1-1-1',
        kpi: [],
        col1: [
            'recap-achat',
            'recap-credit'
        ],
        col2: [
            'recap-loyer',
            'recap-charge'
        ],
        col3: [
            'recap-kpi',
            'repartition-inout'
        ],
    },
    {
        slug: 'dashboard',
        title: 'Mon dashboard',
        template: '1-1-1',
        kpi: [],
        col1: [],
        col2: [],
        col3: [],
    },
];
